import { apiV1 } from '../../http';
import { axiosHttpErrorToError } from '../../utils/errors';

class UnarchiveProfileService {
  async unarchive(id: string): Promise<void> {
    try {
      await apiV1.put<void>(`/profiles/${id}/unarchive`);
    } catch (error) {
      throw axiosHttpErrorToError(error);
    }
  }
}

export default UnarchiveProfileService;
